import styled from 'styled-components';
import { media } from 'designsystem/index';
import ds from 'designsystem';

const MainNavigationBar = styled.div` 
    position: relative;
    display: flex;
    justify-content: flex-end;
    background-color: ${ds.brand('white')};
    width: 100%; 
    flex-direction: column;
    
    ${media.desktop`
      position: fixed;
      flex-direction: row;
      align-items: center;
      height: ${ds.get('navSection.navHeight')};
      padding-right: ${({ paddingRight }) => paddingRight};
      padding-left: ${({ paddingLeft }) => paddingLeft};
      top: 0;
      z-index: 100;
    `}
`;

export default MainNavigationBar;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MainNavigation/MainNavigationBar.jsx